<template lang="pug">
    .z-deal-view(v-if="$props.dealId" v-loader-overlay="progress")
        flex-tabs(v-bind:tabs="tabs" v-model="activeTab" v-bind:min="true")

        .z-deal-view__list(v-if="activeTab == 'tab-customers'")
            ZDealCustomerView.z-deal-view__50(v-if="deal.sender"    v-bind:customer="deal.sender"    v-bind:deal="deal" type="sender"    title="Отправитель")
            ZDealCustomerView.z-deal-view__50(v-if="deal.recipient" v-bind:customer="deal.recipient" v-bind:deal="deal" type="recipient" title="Получатель")
            ZDealCustomerView.z-deal-view__50(v-if="deal.payer"     v-bind:customer="deal.payer"     v-bind:deal="deal" type="payer"     title="Плательщик")
            ZDealCustomerView.z-deal-view__50(v-if="deal.applicant" v-bind:customer="deal.applicant" v-bind:deal="deal" type="applicant" title="Составитель заявки")

        ZFreightView(v-if="activeTab == 'tab-freight'" v-bind:freight="deal.first_freight")
        ZFreightTracking(v-bind:deal="deal" v-bind:freight="deal.first_freight" v-bind:load="(activeTab == 'tab-tracking')" v-show="(activeTab == 'tab-tracking')" v-bind:block="true")
        comments-and-logs(v-if="deal.id && activeTab == 'tab-comments'" v-bind:entity_id="deal.id" entity="deals" module="deals")
</template>
<script>
    import FlexTabs          from './FlexTabs';
    import ZDealCustomerView from './ZDealCustomerView.vue';
    import ZFreightView      from './ZFreightView.vue';
    import ZFreightTracking from './ZFreightTracking.vue';
    import commentsAndLogs   from './CommentsAndLogs';
    export default {
        name: 'z-deal-view',
        components: {FlexTabs, ZDealCustomerView, ZFreightView, ZFreightTracking, commentsAndLogs},
        props: {
            dealId: {
                type: Number,
                defauld: null
            }
        },
        data() {
            return {
                loadKey: 'load-deal-view-card',
                activeTab: 'tab-tracking',
                tabs: [
                    {name: "tab-tracking",  label: "Трекинг"    },
                    {name: "tab-freight",   label: "Груз"       },
                    {name: "tab-customers", label: "Контрагенты"},
                    {name: "tab-comments",  label: "История"    },
                ],
                deal: {}
            }
        },
        created() {
            this.init();
        },
        watch: {
            '$props.dealId'(dealId) {
                if (dealId) this.init();
            }
        },
        computed: {
            progressObj() {
                return this.$store.state.progressObj;
            },
            progress() {
                return this.progressObj[ this.loadKey ];
            }
        },
        methods: {
            init() {
                this.$nextTick(() => {
                    if (this.$props.dealId) this.getDeal(this.$props.dealId);
                });
            },
            getDeal(id) {
                this.$store.commit('showProgressBar', this.loadKey);
                return this.$store.dispatch('deals/getDealById', id).then(deal => {
                    this.deal = Object.assign({}, this.prepareDeal(deal));
                    return this.deal;
                }).finally(() => this.$store.commit('hideProgressBar', this.loadKey));
            },
            prepareDeal(deal) {
                deal.delivery_method_from = parseInt(deal.delivery_method_from);
                deal.delivery_method_to   = parseInt(deal.delivery_method_to);

                if (deal && deal.first_freight && deal.first_freight.full_price && typeof deal.first_freight.full_price == 'string') deal.first_freight.full_price = JSON.parse(deal.first_freight.full_price);

                return deal;
            },
        }
    }
</script>
<style lang="sass">
    .z-deal-view__list
        display: flex
        align-items: flex-start
        justify-content: flex-start
        flex-wrap: wrap
        margin: 0 -10px
        .z-deal-view__50
            width: 50%
        .z-deal-view__list
</style>


// WEBPACK FOOTER //
// ZDealView.vue?68f3d7bb